import styles from './ccf-simulator-v2-inbound-phone-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfSimulatorV2InboundPhoneIconProps {}

export function CcfSimulatorV2InboundPhoneIcon(
  props: CcfSimulatorV2InboundPhoneIconProps
) {
  return (
    <SvgIcon
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      sx={{ fontSize: 20 }}
    >
      <path
        d="M14.4159 14.6734C14.4972 14.5558 15.3781 13.1788 15.3781 13.1788C15.9217 12.2526 18.2454 13.2999 19.3641 14.988C20.188 16.2356 20.1091 16.7831 19.7027 17.3074C19.0257 18.1549 18.2424 18.9191 17.3705 19.5825C16.9158 19.9117 16.344 20.0549 15.7797 19.9809C13.9964 19.7055 12.2927 19.0749 10.7781 18.1298C8.94373 17.0419 7.26829 15.7244 5.79595 14.2121C4.26923 12.7222 2.95241 11.0467 1.87911 9.22841C0.923865 7.69159 0.292274 5.98962 0.0201927 4.21911C-0.0561531 3.65969 0.085596 3.09292 0.418186 2.62778C1.07413 1.76448 1.83824 0.981958 2.6933 0.297869C3.21627 -0.1087 3.76351 -0.189081 5.01209 0.636872C6.70235 1.75406 7.74951 4.07931 6.82369 4.62218C6.82369 4.62218 5.4477 5.50289 5.33 5.58443C5.32364 5.58884 5.31661 5.59352 5.30904 5.59856C5.1766 5.68675 4.87915 5.88482 5.10067 6.65619C5.79502 8.52002 6.95984 10.1895 8.49089 11.5152C10.8958 13.9243 12.4441 14.6489 13.3445 14.9064C14.1172 15.1259 14.3127 14.8295 14.4008 14.696C14.4062 14.6878 14.4112 14.6802 14.4159 14.6734Z"
        fill="black"
      />
      <path
        d="M14.1605 5.45008L14.1408 1.12917C14.14 1.02518 14.1602 0.921581 14.2002 0.824587C14.2401 0.727592 14.2991 0.639191 14.3735 0.564672C14.4479 0.490154 14.5362 0.43105 14.6331 0.390898C14.7301 0.350747 14.8336 0.330374 14.9376 0.330996C15.1524 0.333036 15.3561 0.417962 15.5062 0.568062C15.6563 0.718161 15.7412 0.921841 15.7432 1.13661L15.7636 5.45555L17.4663 5.46243C17.7629 5.46735 17.8686 5.66451 17.7085 5.91008L15.2719 9.60845C15.1118 9.85402 14.8466 9.85003 14.6832 9.60707L12.2173 5.88687C12.0552 5.63997 12.1617 5.44155 12.4558 5.44126L14.1605 5.45008Z"
        fill="black"
      />
    </SvgIcon>
  );
}

export default CcfSimulatorV2InboundPhoneIcon;
